$(document).ready(function(){
var size_li = $(".style-tips div.product_itams").length;

       
 y=4;

   $('.style-tips div.product_itams:lt('+y+')').show();
   $('.style-tips .load_more').click(function () {
  

       y= (y+4 <= size_li) ? y+4 : size_li;
       $('.style-tips .product_itams:lt('+y+')').show();
if(size_li <= y){

$('.style-tips .load_more').hide();
}
   });

var size_li1 = $(".most-popular div.product_itams").length;

       
 m=4;

   $('.most-popular div.product_itams:lt('+m+')').show();
   $('.most-popular .load_more').click(function () {

       m= (m+4 <= size_li1) ? m+4 : size_li1;
       $('.most-popular .product_itams:lt('+m+')').show();
if(size_li1 <= m){

$('.most-popular .load_more').hide();
}
   });
  
  
  
  var size_li2 = $(".editor-picks div.product_itams").length;

       
 n=6;

   $('.editor-picks div.product_itams:lt('+n+')').show();
   $('.editor-picks .load_more').click(function () {

      n= (n+6 <= size_li2) ? n+6 : size_li2;
       $('.editor-picks .product_itams:lt('+n+')').show();
if(size_li2 <= n){

$('.editor-picks .load_more').hide();
}
   });
  
  
   var size_li5 = $(".cat-page div.signle_post").length;

       
 s=10;

   $('.cat-page div.signle_post:lt('+s+')').show();
   $('.cat-page .load_more').click(function () {

       s= (s+10 <= size_li5) ? s+10 : size_li5;
       $('.cat-page div.signle_post:lt('+s+')').show();

if(size_li5 <= s){

$('.cat-page .load_more').hide();
}
   });
  


});





$(document).ready(function() {
  $(".owl-carousel").owlCarousel({
                margin: 10,
                nav: true,
                loop: true,
                responsive: {
                  0: {
                    items: 1
                  },
                  600: {
                    items: 3
                  },
                  1000: {
                    items: 3
                  }
                }
              })
            })


	  

